import React from 'react'
import styled, { keyframes } from 'styled-components'

/**
 * ローディング
 */
const Loading: React.FC = () => {
  return (
    <LoadingArea>
      <LoadingChild1 />
      <LoadingChild2 />
      <LoadingChild3 />
      <LoadingChild4 />
      <LoadingChild5 />
      <LoadingChild6 />
      <LoadingChild7 />
      <LoadingChild8 />
    </LoadingArea>
  )
}

const LoadingArea = styled.div`
  position: relative;
  top: -10px;
  left: -10px;
`

const ballSpin = keyframes`
    50% {
        transform: scale(.4);
        opacity: .3
    }

    100% {
        transform: scale(1);
        opacity: 1
    }
`

const LoadingChild = styled.div`
  position: absolute;
  width: 20px;
  height: 20px;
  margin: 2px;
  background-color: #fff;
  border-radius: 100%;
  animation-fill-mode: both;
`

const LoadingChild1 = styled(LoadingChild)`
  top: 40px;
  left: 0;
  animation: ${ballSpin} 1s -0.96s infinite linear;
`
const LoadingChild2 = styled(LoadingChild)`
  top: 27.28px;
  left: 27.28px;
  animation: ${ballSpin} 1s -0.84s infinite linear;
`
const LoadingChild3 = styled(LoadingChild)`
  top: 0;
  left: 40px;
  animation: ${ballSpin} 1s -0.72s infinite linear;
`
const LoadingChild4 = styled(LoadingChild)`
  top: -27.28px;
  left: 27.28px;
  animation: ${ballSpin} 1s -0.6s infinite linear;
`
const LoadingChild5 = styled(LoadingChild)`
  top: -40px;
  left: 0;
  animation: ${ballSpin} 1s -0.48s infinite linear;
`
const LoadingChild6 = styled(LoadingChild)`
  top: -27.28px;
  left: -27.28px;
  animation: ${ballSpin} 1s -0.36s infinite linear;
`
const LoadingChild7 = styled(LoadingChild)`
  top: 0;
  left: -40px;
  animation: ${ballSpin} 1s -0.24s infinite linear;
`
const LoadingChild8 = styled(LoadingChild)`
  top: 27.28px;
  left: -27.28px;
  animation: ${ballSpin} 1s -0.12s infinite linear;
`

export default Loading
